/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type LinkColumnItem_viewer$ref = any;
export type LinkColumnItem_viewer = {
    readonly doNotShowPrivacyPolicyAlerts: boolean | null;
    readonly " $refType": LinkColumnItem_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "LinkColumnItem_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "doNotShowPrivacyPolicyAlerts",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "doNotShowPrivacyPolicyAlerts"
                }
            ],
            "storageKey": "isEnabled(key:\"doNotShowPrivacyPolicyAlerts\")"
        }
    ]
} as any);
(node as any).hash = '39d41180e1a0f0a292e99d19366280b4';
export default node;
